import { Form, Formik } from 'formik';
import {
  Grid,
  Typography,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress
} from '@mui/material';
import ButtonMain from '../../Shared/ButtonMain';
import useConfirmacaoLoginHook from './useConfirmacaoLoginHook';
import './styles.scss';
import InputToken from './InputToken';

const Confirmacao = ({ logar, tokenCodUser, emailUser, setTela, setMessageLogin }) => {
  const {
    open,
    isPending,
    contador,
    msgCodigoVerificacao,
    bloqueiaBotaoConfirmar,
    modalReenviar,
    reenviarToken,
    validateInputs,
    handleFormSubmit,
    formatTimer,
    inputRefs,
    limpaMsgErro
  } = useConfirmacaoLoginHook({ logar, tokenCodUser, setTela, setMessageLogin });

  return (
    <Grid container className="container-confirmacao">
      <Grid item xl={1} lg={1} md={1} sm={1} xs={1} />
      <Grid item xl={10} lg={10} md={10} sm={10} xs={10} className="padding-container-item">
        <Typography variant="h4" className="texto-negrito texto-centro label-validacao-codigo">
          Valide seu acesso
        </Typography>

        <Typography variant="subtitle1" className="label-validacao-descricao">
          <>Verifique o e-mail </>
          {emailUser}
          <>, e digite o código abaixo para continuar a validação do acesso.</>
        </Typography>

        <Formik
          initialValues={{ TOKENVALIDACAO: '' }}
          validate={validateInputs}
          onSubmit={handleFormSubmit}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({ isSubmitting, values, errors, touched, setFieldValue, setFieldTouched }) => {
            const code = (values.TOKENVALIDACAO || '').replace(/\s/g, '').toUpperCase();
            const isComplete = /^[A-Z0-9]{6}$/.test(code);

            return (
              <Form>
                <Grid container className="container-input-confirmacao-codigo">
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="grid-item-input">
                    <Box display="flex" justifyContent="space-between" className="pin-wrapper">
                      {Array.from({ length: 6 }).map((_, idx) => (
                        <InputToken
                          key={idx}
                          idx={idx}
                          values={values}
                          isPending={isPending}
                          isSubmitting={isSubmitting}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          inputRefs={inputRefs}
                          limpaMsgErro={limpaMsgErro}
                        />
                      ))}
                    </Box>
                  </Grid>
                </Grid>

                <Grid container spacing={2} className="pad-topbot-10">
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <ButtonMain
                      id="btn-validar"
                      type="submit"
                      tipoBotao="principal"
                      disabled={
                        isPending ||
                        isSubmitting ||
                        !isComplete ||
                        (bloqueiaBotaoConfirmar && !isComplete)
                      }
                      className={`button-cor-cliente min-heith-42 ${isPending ? 'loading' : ''}`}
                    >
                      {!isPending && <>Validar</>}
                      {isPending && <CircularProgress size={24} color="inherit" />}
                    </ButtonMain>
                  </Grid>
                </Grid>

                <Grid container className="pad-topbot-10">
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Box className="mt-2">
                      {msgCodigoVerificacao && (
                        <Typography variant="subtitle2" className="mt-3 texto-centro">
                          {msgCodigoVerificacao}
                        </Typography>
                      )}
                    </Box>

                    {contador === 0 ? (
                      <Box className="flex-center box-reenviar-codigo">
                        <Typography variant="subtitle2" className="texto-centro font-size-16">
                          Não recebeu o código?
                        </Typography>
                        <Box onClick={() => reenviarToken()}>
                          <Typography variant="subtitle2" className="label-reenviar font-size-16">
                            Reenviar código
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Typography variant="subtitle2" className="texto-centro">
                        Aguarde para enviar novamente em
                        <b className="texto-cor-principal"> {formatTimer(contador)} </b>
                      </Typography>
                    )}
                  </Grid>
                </Grid>

                <Dialog
                  open={open}
                  keepMounted
                  onClose={() => modalReenviar(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title" className="texto-login-link">
                    Reenviar código
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Deseja realmente reenviar o código de confirmação?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Grid container>
                      <Grid item xl={4} lg={4} md={4} sm={2} />
                      <Grid item xl={4} lg={4} md={4} sm={5} xs={6}>
                        <ButtonMain tipoBotao="transparente" onClick={() => modalReenviar(false)}>
                          Cancelar
                        </ButtonMain>
                      </Grid>
                      <Grid item xl={4} lg={4} md={4} sm={5} xs={6}>
                        <ButtonMain
                          tipoBotao="principal"
                          classesAdicional="btn-reenviar-codigo"
                          onClick={reenviarToken}
                          autoFocus
                        >
                          Reenviar
                        </ButtonMain>
                      </Grid>
                    </Grid>
                  </DialogActions>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
      </Grid>
    </Grid>
  );
};

export default Confirmacao;
